var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCubeTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.202 14.585 5.683 16.6l3.455-2.003M5.683 20.174v-3.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m4.869 12.634-2.102 1.169c-.473.263-.867.926-.867 1.471v2.227c0 .545.387 1.208.867 1.471l2.102 1.17c.446.249 1.182.249 1.635 0l2.102-1.17c.473-.263.867-.926.867-1.471v-2.233c0-.546-.388-1.209-.867-1.472l-2.102-1.169c-.453-.25-1.189-.25-1.635.007ZM14.721 14.6l3.506 2.03 3.48-2.017M18.227 20.229v-3.605"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m17.407 12.635-2.117 1.178c-.476.264-.873.932-.873 1.481v2.243c0 .549.39 1.217.873 1.481l2.117 1.178c.45.251 1.19.251 1.647 0l2.117-1.178c.476-.264.873-.932.873-1.481v-2.25c0-.548-.39-1.216-.873-1.481l-2.117-1.177c-.456-.252-1.197-.252-1.647.006ZM8.46 5.644l3.482 2.016 3.454-2.003M11.942 11.233v-3.58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.127 3.693-2.101 1.17c-.473.262-.867.925-.867 1.47V8.56c0 .545.387 1.208.867 1.471l2.101 1.17c.447.249 1.183.249 1.636 0l2.102-1.17c.473-.263.867-.926.867-1.471V6.327c0-.545-.388-1.209-.867-1.472l-2.102-1.169c-.453-.25-1.189-.25-1.636.007Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m7.707 13 2-2.5M16.707 13l-2-2.5M9.207 17.5h5.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeTree);
export default __webpack_public_path__ + "static/media/cube-tree.ddc50565323df7745170becb84fd0a88.svg";
export { ForwardRef as ReactComponent };